import { useTranslation } from "react-i18next";

import { Agreements, CommunicationEvents, Services, Signature } from "modules/AppointmentDetails/components/KioskCommunicationLog/components";
import { useAppointmentLocation } from "modules/AppointmentDetails/hooks";

import type { KioskCommunication } from "models";

type ContentProps = {
  comm: KioskCommunication;
};

export const Content = ({ comm }: ContentProps) => {
  const { t } = useTranslation();
  const selectedLocation = useAppointmentLocation();

  const { events, agreed_interventions, agreements } = comm;

  return (
    <>
      <CommunicationEvents comm={comm} events={events} />
      <Services services={agreed_interventions} title={t("v8_accepted_scheduled_services", "Accepted scheduled services")} vat={selectedLocation?.vat} />
      <Agreements agreements={agreements} />
      <Signature events={events} />
    </>
  );
};
